import React from "react"
import * as styles from './percentageDonut.module.scss'

export default function PercentageDonut({ value, label }) {
    const radius = 25
    const roundedValue = Math.floor(value)
    const circumference = radius * Math.PI * 2
    const dashFill = circumference * (roundedValue / 100)
    const dashNoFill = circumference - dashFill
    return (
        <div className={styles.container}>
            <div className={styles.circleContainer}>
                <svg className={styles.circle}>
                    <circle className={styles.nofill} cx="35" cy="35" r={radius} fill="none" transform="rotate(-90 35 35)" strokeDashoffset="0" strokeWidth="15" />
                    <circle className={styles.fill} cx="35" cy="35" r={radius} fill="none" transform="rotate(-90 35 35)" strokeDashoffset="0" strokeWidth="15" strokeDasharray={`${dashFill},${dashNoFill}`} />
                </svg>
            </div>
            <div className={styles.textContainer}>
                <p className={styles.value}>{`${parseFloat(value).toFixed(1)}`.replace('.', ',')} %</p>
                <p className={styles.label}>{label}</p>
            </div>
        </div>
    )
}